import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { promotionQueryKeys } from "./promotionQueryKeys";

export function usePromotionList({
  api,
  opts,
}: {
  api: ApiType;
  opts?: Parameters<ApiType["promotionApi"]["find"]>[0];
}) {
  return useQuery({
    queryKey: promotionQueryKeys.list(opts),
    queryFn: async () => {
      return (await api.promotionApi.find({ ...opts })).data;
    },
  });
}
